<template>
  <SoDialog ref="dialog" v-model="value" card-title="Data Not Saved">
    <p class="text-body-1 font-weight-medium mb-6">
      By exiting this page now, the data previously entered in this workflow
      will be lost.
    </p>

    <SoCheckbox
      v-model="confirmExit"
      label="I understand all data entered will be lost"
      class="mb-4"
    />
    <div class="d-flex gap-2 justify-end">
      <SoButton title="Back" type="secondary" large @click="value = false" />
      <SoButton
        title="Confirm and Exit"
        type="danger"
        :disabled="!confirmExit"
        large
        @click="exitWorkflow"
      />
    </div>
  </SoDialog>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoDialog from "@/components/SoDialog.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import SoCheckbox from "@/components/formControls/SoCheckbox.vue"

  export default defineComponent({
    components: { SoCheckbox, SoButton, SoDialog },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
        required: true,
      },
    },
    emits: ["update:modelValue", "onWorkflowExit"],
    data() {
      return {
        confirmExit: false,
      }
    },
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
    },
    methods: {
      exitWorkflow() {
        this.confirmExit = false
        this.$emit("onWorkflowExit")
      },
    },
  })
</script>
